<template>
  <div class="debug-log-panel" v-if="visible">
    <div class="debug-header">
      <span>🔧 调试日志</span>
      <button @click="clearLogs">清空</button>
      <button @click="visible = false">关闭</button>
    </div>
    <div class="debug-content" ref="logContainer">
      <div
        v-for="(log, index) in logs"
        :key="index"
        :class="['log-item', log.type]"
      >
        <span class="log-time">{{ log.time }}</span>
        <span class="log-msg">{{ log.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebugLogPanel',
  data () {
    return {
      visible: true,
      logs: []
    }
  },
  methods: {
    addLog (message, type = 'info') {
      const now = new Date()
      const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
      this.logs.push({ time, message, type })

      // 限制日志数量
      if (this.logs.length > 100) {
        this.logs.shift()
      }

      // 自动滚动到底部
      this.$nextTick(() => {
        if (this.$refs.logContainer) {
          this.$refs.logContainer.scrollTop = this.$refs.logContainer.scrollHeight
        }
      })
    },
    clearLogs () {
      this.logs = []
    },
    info (msg) {
      this.addLog(msg, 'info')
      console.log(msg)
    },
    success (msg) {
      this.addLog(msg, 'success')
      console.log(msg)
    },
    warn (msg) {
      this.addLog(msg, 'warn')
      console.warn(msg)
    },
    error (msg) {
      this.addLog(msg, 'error')
      console.error(msg)
    }
  }
}
</script>

<style scoped>
.debug-log-panel {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  font-family: monospace;
  font-size: 12px;
}

.debug-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #1a1a2e;
  color: #00ff00;
  border-bottom: 1px solid #333;
}

.debug-header span {
  flex: 1;
}

.debug-header button {
  background: #333;
  color: #fff;
  border: none;
  padding: 4px 8px;
  margin-left: 8px;
  border-radius: 4px;
  cursor: pointer;
}

.debug-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.log-item {
  padding: 4px 8px;
  margin-bottom: 2px;
  border-radius: 4px;
  word-break: break-all;
}

.log-item.info {
  color: #ccc;
}

.log-item.success {
  color: #00ff00;
  background: rgba(0, 255, 0, 0.1);
}

.log-item.warn {
  color: #ffaa00;
  background: rgba(255, 170, 0, 0.1);
}

.log-item.error {
  color: #ff4444;
  background: rgba(255, 68, 68, 0.1);
}

.log-time {
  color: #666;
  margin-right: 8px;
}
</style>
